import {Wrapper, Title, Subtitle, FormContainer} from '../styled';

type Props = {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
};

export function PageWrapper({children, title, subtitle}: Props) {
  return (
    <Wrapper className="contacts-verification">
      {title && (
        <div>
          <Title className="contacts-verification__title">{title}</Title>
          {subtitle && (
            <Subtitle className="contacts-verification__subtitle">{subtitle}</Subtitle>
          )}
        </div>
      )}

      <FormContainer className="contacts-verification__form">{children}</FormContainer>
    </Wrapper>
  );
}
